const config = Object.freeze({
  API_URL: 'https://star.starlotto168.com/api/v1/',
  // API_URL: 'https://rich-api.azurewebsites.net/api/v1/'
})

export default config